'use strict';

var d365RedirectController = function(configService, $controller, $window, workflowService) {

    var vm = this;
    angular.extend(vm, $controller('baseStepController'));

    vm.$onInit = function(){
        vm.initializeStep(vm.$stateParams).then(function (executionStep) {
            vm.executionStep = executionStep;

            return workflowService.completeTicketWithoutRedirect(vm.executionStep.ticketStep).then(ticket => {

                configService.getAppSettings().then(settings => {

                    // We moved the handling of the cart sync into the Operations API, so here we just need to send them via redirect
                    // to the API endpoint with the ticket ID, and it will handle the redirect back to Dynamics' cart UI.

                    vm.redirect(`${settings.apiUrl}commerce/checkout/${ticket.id}`);
                });               
            });
        });
    };

    vm.redirect = function(url) {
        $window.onbeforeunload = null;
        $window.location.href = url;
    };
};

d365RedirectController.$inject = ['configService', '$controller', '$window', 'workflowService'];

export var d365RedirectComponent = {
    name: 'd365Redirect',
    controller : d365RedirectController,
    bindings: {
        $stateParams: '<'
    }
};

export var d365RedirectRoute = {
    name: 'd365Redirect',
    url: '/d365Redirect',
    component: 'd365Redirect'
}